<template>
  <v-col cols="12">
    <v-card flat class="pl-5 pr-5 pt-5" :style="styleCard()" height="100%">
      <v-card-title class="font-weight-bold title green--text text--darken-4">
        <v-icon
          v-if="icon != ''"
          class="mr-2"
          color="green darken-4"
          size="28"
          >{{ icon }}</v-icon
        >
        {{ title }}</v-card-title
      >
      <v-card-text class="pt-3">
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-row align-content="center" justify="center">
          <v-col class="mb-3">
            <v-btn
              color="green lighten-4"
              class="font-weight-bold subtitle-1 green--text text--darken-4"
              depressed
              rounded
              block
              style="font-family: Poppins !important"
              min-height="45"
              :to="{ path: path }"
              link
              >Inscreva-se</v-btn
            >
          </v-col>
        </v-row></v-card-actions
      >
    </v-card>
  </v-col>
</template>

<script>
export default {
  props: {
    icon: String,
    title: String,
    path: String,
  },
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    styleCard() {
      return {
        //border: "1px solid #1a5d1f !important",
        "border-radius": "10px !important",
      };
    },
  },
};
</script>

<style>
</style>